<script setup lang="ts">

withDefaults(defineProps<{
  debug?: boolean
  dir?: 'ltr' | 'rtl'
}>(), { 
  debug: false,
  dir: 'ltr',
})
</script>

<template>
<Frame 
  class="m-frame frame-title-directory" 
  :class="[{ debug }, dir]" 
  w="grid grid-cols-[1fr] g-1.5 ds:g-4 d:g-2 max-w-92% mx-auto"
>
  <Frame 
    class="
    col-title 
    h-full 
    grid 
    items-center
    tm:items-start
    dm:items-center
    "
    w="h-full relative col-clamp"
  >
    <slot name="title-before" />
    <slot name="title" />
    <slot name="title-after" />
  </Frame>
  <Frame 
    class="col-directory" w="h-full">
    
    <slot name="directory-before" />
    <slot name="directory" />
    <slot name="directory-after" />
  </Frame>
</Frame>
</template>

<style lang="scss" scoped>
.m-frame {
  &.frame-title-directory {

    .col-media {
      
    }

    .col-content {
      
    }

    &.ltr {
      :deep(>.m-wrap) {
        grid-template-columns: 1.5fr 4fr;

        @include mq($until: tm) {
          grid-template-columns: 1fr;
        }

        .col-title {
          order: 1;
        }
        .col-directory {
          order: 2;
        }
      }
    }
    &.rtl {
      :deep(>.m-wrap) {
        grid-template-columns: 4fr 1.5fr;

        @include mq($until: ds) {
          grid-template-columns: 1fr;
        }
        .col-title {
          order: 2;
          @include mq($until: ds) {
            order: 1
          }
        }
        .col-directory {
          order: 1;
          @include mq($until: ds) {
            order: 2
          }
        }
      }
    }

  }

  &.debug {
    box-shadow: inset 0 0 0 1px red;

    :deep(>.m-wrap) {
      box-shadow: inset 0 0 0 1px blue;

      >.m-col {
        &:nth-child(1) {
          box-shadow: inset 0 0 0 1px green;
          >.m-wrap {
            box-shadow: inset 0 0 0 1px lightgreen;
          }
        }

        &:nth-child(2) {
          box-shadow: inset 0 0 0 1px orange;
          >.m-wrap {
            box-shadow: inset 0 0 0 1px lightorange;
          }
        }

        &:nth-child(3) {
          box-shadow: inset 0 0 0 1px purple;
          >.m-wrap {
            box-shadow: inset 0 0 0 1px lightpurple;
          }
        }

        &:nth-child(3) {
          box-shadow: inset 0 0 0 1px pink;
          >.m-wrap {
            box-shadow: inset 0 0 0 1px lightpink;
          }
        }
      }
    }
  }
}
</style>